import React, { useMemo } from "react";
import { getAccuratePixels } from "../../utils/global";

function TvSocket({ isDownloadMode, downloadAs }) {
  const width = isDownloadMode ? 209 : getAccuratePixels(209);
  const height = isDownloadMode ? 209 : getAccuratePixels(209);

  const totalWidth = isDownloadMode ? 283 : getAccuratePixels(283);
  const totalHeight = isDownloadMode ? 596 : getAccuratePixels(596);

  const border = useMemo(() => {
    if (downloadAs == "cutout-png") {
      return "1px solid black";
    }

    if (downloadAs == "icon-png") {
      return null;
    }

    return "2px solid #6495ED";
  }, [downloadAs]);

  return (
    <div
      style={{
        width: totalWidth,
        height: totalHeight,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          width: width,
          height: height,
          border: border,
          borderRadius: "50%",
        }}
      ></div>
    </div>
  );
}

export default TvSocket;
